<template>
  <the-header v-bind:titleFromProp="header" v-bind:department="department">
  </the-header>
  
  <the-resources></the-resources>
</template>

<script>
import TheHeader from './layout/TheHeader.vue';
import TheResources from '@/components/fchq/pages/TheResources.vue';

export default {
  name: 'FCHQCALENDAR',
  data() {
    return {
      header: 'Community Business Hub Space',
      department: 'FCHQ',
    };
  },
  components: { TheHeader, TheResources },
};
</script>

<style>
.vue__time-picker .controls .char {
  color: white;
  font-size: 2em;
}

.vue__time-picker .dropdown ul li:not([disabled]).active,
.vue__time-picker .dropdown ul li:not([disabled]).active:hover,
.vue__time-picker .dropdown ul li:not([disabled]).active:focus {
  background: #00509e;
  color: #fff;
}

.vue__time-picker input.vue__time-picker-input {
  padding: 0em 0.5em;
  font-size: 0.9em;
  /* font-family: inherit; */
}

header {
  background-color: #c9c2c0;
}

@import url('https://fonts.googleapis.com/css2?family=Nanum+Gothic&display=swap');

* {
  box-sizing: border-box;
}

/* html {
   font-family: 'Roboto', sans-serif; 
} */

body {
  margin: 0;
  /* min-height: 1200px; */
}

div {
  margin-left: auto;
  margin-right: auto;
  margin-bottom: 0 !important;
}
</style>
